import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greenMui, greyMui, rydeColors } from "@ryde/theme";

import { KANBAN_CARD_HEIGHT, KANBAN_CARD_WIDTH } from "./const";

export const KanbanCardStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "kanban-item",
})`
  position: relative;
  width: ${KANBAN_CARD_WIDTH}px;
  height: ${KANBAN_CARD_HEIGHT}px;
  border-radius: 6px;
  background-color: ${rydeColors.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid ${greyMui._300};
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.15);
  border-top: 30px solid ${rydeColors.lightGreyBorder};

  &.waiting_drop {
    opacity: 0.2;
    outline: 3px solid ${greenMui._300};
  }
  &.drag_clone {
    user-select: none;
    outline: 3px solid ${greenMui._500};
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.25);
  }
  &.after_edit_highlighted {
    outline: 3px solid ${rydeColors.dragBorderColor};
    box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
  }
`;
